import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {fieldList_template} from "../components/templates/fieldList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class field extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected fieldList: fieldList_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.fieldList = new fieldList_template("fieldList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Fields List");
        return [this.fieldList.build()];
    }

    protected getModuleName(): string {
        return "field";
    }

    fillPage() {
        this.getFieldData();
    }

    protected getFieldData() {
        this.loadingIn(this.fieldList.builtTemplate.children.namedItem("list-results"));
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.fieldList.getViewModelForRequest())]);

        let url: string = '/api/brand/' + idBrand + "/field/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.ongetFieldDataReturn;
        this.XHRHdl.execute();
    }

    protected ongetFieldDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount
                let totalPage = responseParsed.totalPage
                let fields = responseParsed.data;


                obj.viewModel.fieldList.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.fieldList.setResultInfo(totalCount, totalPage, execTime)

                obj.fieldList.setFields(fields, obj.getBrandId())

            });
            obj.loadingOut(obj.fieldList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected fieldsListReorder() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.getFieldData()
    }

    protected paginationOnPageClick() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.getFieldData();
    }

    protected filterSimpleOnChange(){

        this.viewModel.fieldList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.fieldList.builtTemplate.children.namedItem("list-results"));

        let fieldReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/field/get/';
        let fieldReq_params: Array<Array<string>> = [];
        fieldReq_params.push(["data", ko.toJSON(this.fieldList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(fieldReq_url,fieldReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.fieldList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any){

        // set fields list
        let fieldsToSet = [];
        for (let item of responseParsed.data) {
            fieldsToSet.push( {
                id: item.id,
                idField: item.idField,
                label: item.label,
                type: item.type,
                dateCreated: item.dateCreated,
                dateUpdated: item.dateUpdated
            })
        }

        this.fieldList.setFields(fieldsToSet, this.getBrandId());

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.fieldList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.viewModel.fieldList.pagination.itemCount(responseParsed.totalCount);
    }

    protected viewField(id) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/fields/view/' + id + '/')
    }

    protected addField() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/fields/add/')
    }

    protected deleteField(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/field/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.fieldList.builtTemplate.children.namedItem("list-results"));
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Field" + "<strong>" + data.label + "</strong>" + "was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.getFieldData()
                })

                obj.loadingOut(obj.fieldList.builtTemplate.children.namedItem("list-results"));
            }
        });
        XHRHdl.execute();
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }
}


// WEBPACK FOOTER //
// ./js/modules/field.ts